import { useState } from 'react';
import { cn } from '@/lib/utils';

/**
 * The reserved line under the composer. A message rises in from below; when it
 * clears it sinks back out the way it came, so the text stays mounted until the
 * exit animation ends. Blank otherwise, with its height kept so nothing jumps.
 */
export const Guidance = ({ message }: { message: string | null }) => {
  const [shown, setShown] = useState(message);
  const [previous, setPrevious] = useState(message);
  if (message !== previous) {
    setPrevious(message);
    if (message) setShown(message);
  }
  const leaving = !message && shown !== null;

  return (
    <p className='mt-2 min-h-4 overflow-hidden text-center text-[11px] leading-4 text-muted-foreground'>
      {shown && (
        <span
          key={shown}
          onAnimationEnd={() => leaving && setShown(null)}
          className={cn(
            'inline-block',
            leaving
              ? 'animate-out fill-mode-forwards fade-out-0 slide-out-to-bottom-full duration-200 ease-in'
              : 'animate-in fade-in-0 slide-in-from-bottom-full duration-300 ease-out'
          )}
        >
          {shown}
        </span>
      )}
    </p>
  );
};
